import { css } from 'emotion'

export const textBiggerStyles = css`
  font-size: 1.4em;
`
